import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'cp-column',
  template: ``
})
export class ColumnComponent {
  @Input()
  header?: string;

  @Input()
  field?: string;

  @Input()
  filter?: boolean;

  @Input()
  sortable = true;

  @Input()
  columnClass?: string;

  @Input()
  headerClass?: string;

  @Input()
  bodyClass?: string | ((row: any) => string | { [key: string]: boolean });

  @Input()
  sortByLabel?: boolean;

  @ContentChild(TemplateRef)
  template?: TemplateRef<any>;

  calculateBodyClass(row: any) {
    if (!this.bodyClass) {
      return this.bodyClass;
    }

    return typeof this.bodyClass === 'string'
      ? this.bodyClass
      : this.bodyClass(row);
  }
}
